"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var billing;
        (function (billing) {
            var invoices;
            (function (invoices) {
                class InitArgs {
                    constructor() {
                        this.billingPayInvoice = appn.emptyString;
                        this.entityId = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    createDataTable();
                }
                invoices.init = init;
                function createDataTable() {
                    const oTable = appn.dataTable.create('.dataTable', {
                        sDom: appn.dataTable.genSDom(0, 0, 0),
                        iDisplayLength: 25,
                        bProcessing: true,
                        bServerSide: true,
                        sAjaxSource: 'InvoicesDataTable',
                        fnServerData: function (data) {
                            data.push({ name: 'sCustom_0', value: _initArgs.entityId });
                        },
                        aoColumns: [
                            { bSortable: false, sWidth: '12%' },
                            { bSortable: false, sWidth: '30%' },
                            { bSortable: false, sWidth: '12%' },
                            { bSortable: false, sWidth: '12%' },
                            { bSortable: false, sWidth: '12%' },
                            { bSortable: false, sWidth: '12%' },
                            { bSortable: false, sWidth: '10%' }
                        ],
                        searching: false,
                        fnInitComplete: function () {
                            appn.saveMeState.init(function () {
                                oTable.fnDraw(false);
                            }, function () {
                                oTable.fnDraw(false);
                            }, '.dataTables_filter');
                        },
                        fnDrawCallback: function () {
                            $('.payBtn').click(function () {
                                const invoiceno = $(this).data('inv');
                                const invoiceamt = $(this).data('amt');
                                const invid = $(this).data('invid');
                                const entityId = $(this).data('ent');
                                appn.dialog.confirm({
                                    modalColor: 'modal-primary',
                                    title: T('Pay This Invoice Now?'),
                                    message: T(`Invoice <span class='payInvoiceNo text-bold'>{0}</span> will be paid using the credit card we have on file.<br /><br />Press the OK button to make immediate payment of <span class='payInvoiceAmt text-bold'>{1}</span>.`, invoiceno, invoiceamt),
                                    buttons: {
                                        confirm: {
                                            label: '<span>' + T('OK') + '</span>',
                                            className: 'btn-success'
                                        }
                                    },
                                    callback: function (result) {
                                        if (result)
                                            appn.location.navTo(_initArgs.billingPayInvoice, [
                                                { name: 'invoiceno', value: invoiceno },
                                                { name: 'invoiceid', value: invid },
                                                { name: 'entityid', value: entityId }
                                            ]);
                                    }
                                });
                            });
                        }
                    });
                }
            })(invoices = billing.invoices || (billing.invoices = {}));
        })(billing = views.billing || (views.billing = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
